import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { slice1Actions } from "../../store/reducer";
import "./Modal.css";
import "./FlightStatusDialog.css";
import PromptModal from "./PromptModal";

// A trip can have multiple flights (outbound, return, connections), so
// these are kept as a list on the guide itself — window.guide_obj.flights
// — the same "mutate directly, persist on the user's next manual Save
// Guide" convention destinations already use (see DestinationsScreen.js).
const FlightStatusDialog = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const [showAddPrompt, setShowAddPrompt] = useState(false);
  const [, forceRerender] = useState(0);

  const flights = window.guide_obj?.flights || [];

  const persist = (next) => {
    window.guide_obj.flights = next;
    dispatch(slice1Actions.setGuide({ guide: null }));
    forceRerender((n) => n + 1);
  };

  const addFlight = (inputs) => {
    setShowAddPrompt(false);
    const number = (inputs?.[0]?.value || "").trim().toUpperCase().replace(/\s+/g, "");
    if (!number) return;
    const label = (inputs?.[1]?.value || "").trim();
    persist([...flights, { id: Date.now(), number, label }]);
  };

  const removeFlight = (id) => {
    persist(flights.filter((f) => f.id !== id));
  };

  const openStatus = (number) => {
    const win = window.open(`https://www.flightaware.com/live/flight/${encodeURIComponent(number)}`, "_blank");
    if (win) win.focus();
  };

  return (
    <>
      <div className="modal">
        <Modal
          show={show}
          onHide={onHide}
          animation={false}
          dialogClassName="fs-dialog"
          aria-labelledby="fs-title"
          centered
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="fs-shell">

              <div className="fs-header">
                <div className="fs-header-icon">
                  <FontAwesomeIcon icon={solid("plane")} />
                </div>
                <h2 className="fs-title" id="fs-title">Flight Status</h2>
                <button className="fs-close" onClick={onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              <div className="fs-body">
                {flights.length === 0 && (
                  <p className="fs-empty">
                    No flights added yet for this trip.
                  </p>
                )}
                {flights.map((f) => (
                  <div key={f.id} className="fs-row">
                    <button className="fs-row-main" onClick={() => openStatus(f.number)}>
                      <span className="fs-row-number">{f.number}</span>
                      {f.label && <span className="fs-row-label">{f.label}</span>}
                    </button>
                    <button
                      className="fs-row-remove"
                      onClick={() => removeFlight(f.id)}
                      aria-label={`Remove ${f.number}`}
                    >
                      <FontAwesomeIcon icon={solid("trash")} />
                    </button>
                  </div>
                ))}
                <button className="fs-add-btn" onClick={() => setShowAddPrompt(true)}>
                  <FontAwesomeIcon icon={solid("plus")} /> Add Flight
                </button>
              </div>

            </div>
          </Modal.Body>
        </Modal>
      </div>

      {showAddPrompt && (
        <PromptModal
          show={true}
          onHide={() => setShowAddPrompt(false)}
          PromptModalTitle="Add Flight"
          PromptModalMessage="Enter the flight number (e.g. UAL1763) and an optional label."
          PromptModalInputs={[
            { name: "Flight Number", value: "" },
            { name: "Label (optional)", value: "" },
          ]}
          PromptModalButtons={[
            { Title: "Add", Method: addFlight },
            { Title: "Cancel", Method: null },
          ]}
        />
      )}
    </>
  );
};

export default FlightStatusDialog;
